import { request } from '@/api/index';
export function getList(data) {
  return request({
    url: '/api/AuthorizationTemplate/Data',
    method: 'get',
    params: data
  });
}
export function getDetail(params) {
  return request({
    url: '/api/AuthorizationTemplate/Get',
    method: 'get',
    params: params
  });
}
export function edit(params, data) {
  return request({
    url: '/api/AuthorizationTemplate/Edit',
    method: 'post',
    data: data,
    params: params
  });
}
export function create(data) {
  return request({
    url: '/api/AuthorizationTemplate/Create',
    method: 'post',
    data: data
  });
}
export function deleteItems(data) {
  return request({
    url: '/api/AuthorizationTemplate/Delete',
    method: 'post',
    data: data
  });
}